import React from 'react'
import SavingImg1 from '../../Images/SavingImg/ChildSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const ChildSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>बाल बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>बाल सदस्यले ऐच्छिक रूपमा बचत गर्न सक्ने ।</li>
                                        <li>न्यूनतम बचतभन्दा बढि बचत गर्न सकिने ।</li>
                                        <li>१६ बर्ष उमेरसम्म बचत गरिराख्नु पर्ने ।</li>
                                        <li>इच्छानुसार नागरिकता प्राप्त भएपछि स्वतः सदस्यता प्रदान गरिने । </li>
                                        <li>बालबालिकाहरूका लागि सचेतना तथा नेतृत्व सम्बन्धी कार्यक्रम सञ्चालन गर्ने । </li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                    </ul>

                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default ChildSaving